import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MapLocation } from '../utils/dashboard-map-types';
import { ApiService } from '../../../services/api/api.service';

export interface MapPanelData {
  vehicle: any,
  case: any,
  appointment: any,
  caseVehicles: any[]
  org: any
}

@Component({
  selector: 'app-map-location-info',
  templateUrl: './map-location-info.component.html',
  styleUrl: './map-location-info.component.scss'
})
export class MapLocationInfoComponent implements OnDestroy {

  @Output() personelInfoClicked = new EventEmitter<any>();
  @Output() panelClosed = new EventEmitter<any>();
  @Output() panelUpdated = new EventEmitter<{type: string, id: number}[]>();

  isOpen: boolean = false;
  location: MapLocation;
  activeTab: string;

  allData: MapPanelData;
  secondaryTabs: string[] = [];
  activeCaseVehicle: number = -1;

  private slaInterval: any;
  timeDisplay: string = '';
  isSlaNegative: boolean = false;

  loading: boolean = true;
  lastUpdate: Date | undefined;

  constructor(private readonly apiService: ApiService) {}

  ngOnDestroy(): void {
    if(this.slaInterval) {
      clearInterval(this.slaInterval);
    }
  }

  open(location: MapLocation) {
    this.loading = true;
    this.isOpen = true;
    this.secondaryTabs = [];
    this.activeCaseVehicle = -1;
    this.location = location;
    this.activeTab = location.type;
    this.lastUpdate = undefined;
    this.getLocationInfo();
  }

  refresh() {
    if(!this.isOpen) {return;}
    this.getLocationInfo();
  }

  private getLocationInfo() {
    this.apiService.post<any>(`dashboard-map/location-info`, this.location)
    .subscribe(res => {
      this.allData = res;
      this.secondaryTabs = Object.keys(res).filter( key => this.location.type !== key && key !== 'caseVehicles');

      //  Çoklu araç ilişkilendirmesi
      for (let i = 0; i < res.caseVehicles.length; i++) {
        if(res.caseVehicles) {
          this.secondaryTabs.push((i+1).toString());
        }
      }

      this.loading = false;
      this.lastUpdate = new Date();

      if(res.vehicle) {
        this.updateTime(this.allData.vehicle);

        if(this.slaInterval) {
          clearInterval(this.slaInterval);
        }
        this.slaInterval = setInterval(() => {
          this.updateTime(this.allData.vehicle);
        }, 1000);

      } else if(this.slaInterval) {
        clearInterval(this.slaInterval);
      }

      // Takip çizgileri çizilmesi için ilişkili lokasyon bilgileri
      const trackData = this.secondaryTabs.map(tab => {
        switch (tab) {
          case 'vehicle':
          case 'case':
          case 'org': {
            return { type: tab, id: this.allData[tab].id };
          }
          case 'appointment': {
            return { type: 'res', id: this.allData[tab].id };
          }
          default: {
            // Çoklu araçlar için
            const vehicleIndex = Number(tab) - 1;
            return { type: 'vehicle', id: this.allData.caseVehicles[vehicleIndex].id };
          }
        }
      });


      this.panelUpdated.emit(trackData);
    
    });
  }

  close() {
    this.isOpen = false;
    if(this.slaInterval) {
      clearInterval(this.slaInterval);
    }
    this.panelClosed.emit();
  }

  tabClicked(tab: string) {

    this.activeTab = tab;
    this.activeCaseVehicle = -1;

    if(this.activeTab === 'vehicle') {
      this.updateTime(this.allData.vehicle);
    } else if (!['case', 'appointment', 'org'].includes(tab)) {
      this.activeCaseVehicle = Number(tab)-1;
      console.log()
      this.updateTime(this.allData.caseVehicles[this.activeCaseVehicle]);
    }

  }

  private updateTime(data: any) {
    if (!['case', 'appointment', 'org'].includes(this.activeTab)) {return;};

    const sla = data.mobileStatus.sla;

    const end = data.mobileStatus.endDate
      ? new Date(data.mobileStatus.endDate)
      : new Date();
    const start = new Date(data.mobileStatus.startDate);

    const ms = end.getTime() - start.getTime();
    const totalElapsedMinutes = ms / 1000 / 60;

    this.isSlaNegative = totalElapsedMinutes > sla;

    const diffMinutes = Math.abs(totalElapsedMinutes - sla);
    const totalSeconds = Math.floor(diffMinutes * 60);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hourStr = hours > 0 ? `${hours.toString().padStart(2, '0')}:` : '';
    const minuteStr = minutes.toString().padStart(2, '0');
    const secondStr = seconds.toString().padStart(2, '0');

    this.timeDisplay = (this.isSlaNegative ? '-' : '') + `${hourStr}${minuteStr}:${secondStr}`;
  }

  checkStaff(data: any) {
    this.personelInfoClicked.emit(data);
  }

}
